import FormConfig from "../formConfig.js";
import {
  fun_PostAction,
  fun_GetAction,
  fun_UploadImg,
  fun_Download
} from "@/api/index";
import { Loading } from "element-ui";
// 引入转译方法
import { fun_DownloadFile } from "@/utils/validate";
export default {
  data() {
    return {
      // 全局加载
      fullLoading: false,
      // 列表loading状态
      loading: false,
      // 表单对象
      form: {
        id: null, // 主键
        fileType: null, // 文件类型
        fileName: null, // 文件名
        filePath: null, // 文件路径
      },
      // 表单错误
      errRules: {
        id: null, // 主键
        fileType: null, // 文件类型
        fileName: null, // 文件名
        filePath: null, // 文件路径
      },
      // 表单配置
      formConfigList: FormConfig.configList(),
      controllerFlg: null,// 操作标志
      id: null,  // 主键
      pictureFiles: [], // 文件
      fileUrl: null, // 图片压缩.zip的文件路径
    };
  },
  // 模板编译完成
  mounted() {
    // 打开loading
    this.loading = true;
    // 获取数据
    this.controllerFlg = this.$route.query.type; // 操作标志
    this.id = this.$route.query.id;  // 主键
    // 获取详情信息
    this.fun_Details();
    // 获取图片压缩.zip的路径
    this.fun_GetFileUrl();
    // 如果是详情或者撤回
    if (this.controllerFlg == "details") {
      // 遍历表单
      this.formConfigList.map(e => {
        // 遍历
        e.formConfigList.map(form => {
          // 不可编辑
          form.disabled = true;
        });
      });
    }
  },
  // 自定义方法
  methods: {
    /**
     * @description 详情
     * @author
     */
    fun_Details() {
      // 请求，获取结果集
      fun_PostAction("/downloadCenter/detail", {
        id: this.id, // 主键
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 数据回显
          this.form = data;
          // 关闭loading
          this.loading = false;
        }
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
     * 确定
     */
    fun_InsUpd(){
      // 表单验证
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 如果上传附件为空
          if (this.pictureFiles.length == 0) {
            // 请求失败，弹出失败msg的消息提示
            this.$message.error("请上传附件信息！");
            return;
          }
          // 全局加载框
          this.fullLoading = Loading.service({
            lock: true,
            text: "加载中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.8)"
          });
          try {
            // 定义formData
            let formData = new FormData();
            // 遍历表单
            for (const key in this.form) {
              // 字段值不为空
              if(this.form[key] != "" && this.form[key] != null){
                // 放入FormData中
                formData.append(key, this.form[key]);
              }
            }
            // 如果上传附件不为空
            if (this.pictureFiles.length > 0) {
              // 设置文件
              formData.append("file", this.pictureFiles[0].raw);
            }
            // 请求
            fun_UploadImg("/downloadCenter/saveOrUpdate", formData).then(res => {
              // 加载框取消
              this.fullLoading.close();
              // 解构res.data
              const { result, data, msg } = res.data;
              // 解析后台返回的结果集，判断是否成功
              if (result) {
                // 操作成功
                this.$message.success(msg);
                // 返回一览
                this.fun_Back();
              } else {
                // 如果页面验证失败
                if (data != null && data != "") {
                  // 返回错误消息
                  this.errRules = data;
                  // 请求失败，弹出失败msg的消息提示
                  this.$message.error("您输入的数据存在错误！");
                } else {
                  // 请求失败，弹出失败msg的消息提示
                  this.$message.error(msg);
                }
              }
              // 关闭loading
              this.loading = false;
            });
          } catch (e) {
            // 请求失败，弹出失败msg的消息提示
            this.$message.error("操作失败！" + e);
            // 加载框取消
            this.fullLoading.close();
          }
        }
      });
    },
    /**
     * 文件上传
     */
    fun_FileDetail(file, fileList) {
      // 获取文件后缀名
      const suffix = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();
      // 这里限定上传文件文件类型不能为exe、js等文件，如果文件类型不符，提示错误信息
      if (suffix == 'exe' || suffix == 'js'){
        // 清除验证不通过的文件
        this.fun_ClearFile(file, "fileUpload");
        // 提示错误消息
        this.$message.error("错误提示:文件格式有误，不能上传exe、js等文件，请确认后上传！");
        // 返回
        return false;
      }
      // 如果上传文件大于1
      if (fileList.length > 1) {
        // 根据下标删除列表中的文件
        this.$refs[fileList].uploadFiles.splice(0, 1);
      }
      // 加入集合
      this.pictureFiles.push(file);
    },
    /**
     * 清空文件
     */
    fun_ClearFile(file, refsName) {
      // 获取上传文件的uid
      const uid = file.uid;
      // 获取超过限制大小文件的下标
      const idx = this.$refs[refsName].uploadFiles.findIndex(
          item => item.uid === uid
      );
      // 清空附件列表
      this.$refs[refsName].uploadFiles.splice(idx, 1);
    },
    /**
     * 文件下载
     */
    fun_Download(e) {
      // 获取id
      fun_Download("/downloadLocal?filePath=" + e).then(res => {
        if (res) {
          if (res.data.type === "application/json") {
            this.$message.error("文件不存在！");
            return;
          }
          // 获取头部
          let fileNames = res.headers["content-disposition"]; //获取到Content-Disposition;filename
          let regFileNames = fileNames.match(/=(.*)$/)[1];
          fun_DownloadFile(res, decodeURIComponent(regFileNames));
        }
      });
    },
    /**
     * 获取图片压缩.zip的路径
     * @author shuhua
     */
    fun_GetFileUrl() {
      // 发起请求
      fun_GetAction("/clientFileInfo/getAutomaticallyUpdateFiles", {
        number: 2,
        appName: "图片压缩"
      }).then(res => {
        // 解构res.data
        const {
          result,
          data
        } = res.data;
        // 操作成功
        if (result) {
          // 图片压缩.zip的路径
          this.fileUrl = data;
        }
      });
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    },
  }
};
